import React, { useState, useRef, useEffect } from "react";
import Header from "../Utils/Header/Header";
import Footer from "../Utils/Footer/Footer";
import BaseUrl from "../Utils/BaseUrl";
import ApiSuffix from "../Utils/ApiSuffix";

import {
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Typography,
  Paper,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import { CloudUpload, CheckCircle, Search } from "@mui/icons-material";

import "./AbstractForm.css";
import AbstractGuidlinesData from "./AbstractGuidelinesData";
import AbsoluteBg from "../Utils/AbsoluteBg/AbsoluteBg";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AbstractForm = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [delegateData, setDelegateData] = useState({
    fullName: "",
    email: "",
    contact: "",
  });

  // Verification State
  // const [contactNumber, setContactNumber] = useState("");

  // Data State
  // const [delegateData, setDelegateData] = useState(null);
  const [submissionCategory, setSubmissionCategory] = useState("");
  const [documentUrl, setDocumentUrl] = useState(null);

  // Dialog State
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    message: "",
    isError: false,
  });

  const fileInputRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 1. Verify Registration ID
  // const handleVerify = async () => {
  //   if (contactNumber.length !== 10) {
  //     setDialog({
  //       open: true,
  //       title: "Invalid Contact Number",
  //       message: "Please enter a valid 10-digit registered mobile number.",
  //       isError: true,
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   const url = `${BaseUrl.dev}${ApiSuffix.getContact}${contactNumber}`;

  //   fetch(url, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //     },
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Registration number not found or incorrect number.");
  //       }
  //       return response.json();
  //     })

  //     .then((data) => {
  //       if (data && (data.first_name || data.email)) {
  //         setDelegateData({
  //           id: data.id,
  //           fullName: `${data.first_name} ${data.last_name || ""}`,
  //           email: data.email,
  //           contact: data.contact,
  //           institution: data.institution || "",
  //           country: data.country || "",
  //         });
  //         setActiveStep(2);
  //       } else {
  //         throw new Error("Invalid Registration number or empty data.");
  //       }
  //     })
  //     .catch((err) => {
  //       setDialog({
  //         open: true,
  //         title: "Verification Failed",
  //         message: err.message || "Could not verify ID. Please check and try again.",
  //         isError: true,
  //       });
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // 2. File Upload Handler
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);

    const url = "https://satyasolar.pythonanywhere.com/api/upload-doc/";
    const uploadData = new FormData();
    uploadData.append("image", file);
    uploadData.append("fileName", `abstract-${delegateData.contact || "user"}-${file.name}`);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: uploadData,
      });

      if (!response.ok) throw new Error("Upload failed");

      const data = await response.json();
      setDocumentUrl(data);
    } catch (error) {
      setDialog({
        open: true,
        title: "Upload Error",
        message: "File upload failed. Please try again.",
        isError: true,
      });
    } finally {
      setUploading(false);

      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  const handleSubmit = () => {
    if (!delegateData.fullName.trim() || !delegateData.email.trim() || !delegateData.contact.trim()) {
      setDialog({
        open: true,
        title: "Invalid Details",
        message: "Please fill Name, Email and Contact Number.",
        isError: true,
      });
      return;
    }
    if (!submissionCategory || !documentUrl) {
      setDialog({
        open: true,
        title: "Missing Information",
        message: "Please select a category and upload the abstract document.",
        isError: true,
      });
      return;
    }

    setLoading(true);
    const url = BaseUrl.dev + ApiSuffix.submitAbstract;

    const payload = {
      slug: "e-miss-cvj-2026",
      name: delegateData.fullName,
      email: delegateData.email,
      phone_number: delegateData.contact,
      submission_category: submissionCategory,
      document: documentUrl,
    };

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        if (data.error) {
          throw new Error(data.error_msg || "Submission failed");
        }

        setDialog({
          open: true,
          title: "Success",
          message: "Your abstract has been submitted successfully.",
          isError: false,
        });

        setDocumentUrl(null);
        setSubmissionCategory("");
        setDelegateData({
          fullName: "",
          email: "",
          contact: "",
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      })
      .catch((error) => {
        setDialog({
          open: true,
          title: "Submission Error",
          message: error.message || "Failed to submit abstract.",
          isError: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseDialog = () => {
    setDialog({ ...dialog, open: false });
    if (!dialog.isError) {
      window.location.reload(); // Refresh page on success
    }
  };

  return (
    <>
      <Header />
      <div className="component-container">
        <div className="abstract-page-wrapper">
          <AbsoluteBg />
          <div className="abstract-heading">
            <h1>Abstract Submission</h1>
          </div>

          <div className="stepper-container">
            <Stepper activeStep={activeStep} alternativeLabel>
              <Step>
                <StepLabel>Guidelines</StepLabel>
              </Step>
              {/* <Step>
                <StepLabel>Verification</StepLabel>
              </Step> */}
              <Step>
                <StepLabel>Submission</StepLabel>
              </Step>
            </Stepper>
          </div>

          {/* --- STEP 1: GUIDELINES --- */}
          {activeStep === 0 && (
            <Paper elevation={3} className="abstract-section guidelines-box">
              <Typography variant="h5" className="section-title">
                Submission Guidelines
              </Typography>

              <div className="guidelines-content">
                <h2>{AbstractGuidlinesData.title}</h2>

                {AbstractGuidlinesData.content.map((item, index) => (
                  <div key={index} className="guideline-block">
                    <h3>{item.heading}</h3>

                    {item.text && <p>{item.text}</p>}

                    {item.list && (
                      <ul>
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>

              <div className="action-row">
                <Button variant="contained" color="primary" onClick={() => setActiveStep(1)}>
                  I Agree & Proceed
                </Button>
              </div>
            </Paper>
          )}

          {/* step -2 verifcation */}
          {/* {activeStep === 1 && (
            <Paper elevation={3} className="abstract-section verification-box">
              <Typography variant="h5" className="section-title">
                Registration Verification
              </Typography>
              <Typography variant="h6" className="section-paragraph">
                Please enter your <strong>registered contact number</strong> to proceed.
              </Typography>

              <div className="verify-input-group">
                <TextField
                  label="Registered Contact Number"
                  variant="outlined"
                  fullWidth
                  value={contactNumber}
                  onChange={(e) => setContactNumber(e.target.value.replace(/\D/g, "").slice(0, 10))}
                  placeholder="10-digit mobile number"
                />

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleVerify}
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Search />}>
                  {loading ? "Checking..." : "Verify"}
                </Button>
              </div>
            </Paper>
          )} */}

          {/* --- STEP 3: FORM --- */}
          {activeStep === 1 && (
            <Paper elevation={3} className="abstract-section form-box">
              <Typography variant="h5" className="section-title">
                Submit Abstract
              </Typography>

              <div className="form-grid">
                {/* Auto-filled Read-only Fields */}
                <TextField
                  label="Name"
                  fullWidth
                  value={delegateData.fullName}
                  onChange={(e) => setDelegateData({ ...delegateData, fullName: e.target.value })}
                />

                <TextField
                  label="Email"
                  fullWidth
                  value={delegateData.email}
                  onChange={(e) => setDelegateData({ ...delegateData, email: e.target.value })}
                />

                <TextField
                  label="Contact"
                  fullWidth
                  inputProps={{ maxLength: 10 }}
                  value={delegateData.contact}
                  onChange={(e) =>
                    setDelegateData({
                      ...delegateData,
                      contact: e.target.value.replace(/\D/g, ""),
                    })
                  }
                />

                {/* Submission Category */}
                <FormControl fullWidth>
                  <InputLabel>Submission Category</InputLabel>
                  <Select
                    value={submissionCategory}
                    label="Submission Category"
                    onChange={(e) => setSubmissionCategory(e.target.value)}>
                    <MenuItem value="Poster Presentation">Poster Presentation</MenuItem>
                    <MenuItem value="Oral Presentation">Oral Presentation</MenuItem>
                    <MenuItem value="Award Paper">Award Paper</MenuItem>
                  </Select>
                </FormControl>

                {/* File Upload */}
                <div className="file-upload-section">
                  <Typography variant="subtitle1" gutterBottom>
                    Upload Abstract Document
                  </Typography>

                  <Typography variant="caption" display="block" gutterBottom>
                    (Supported formats: .doc, .docx, .pdf)
                  </Typography>

                  <input
                    type="file"
                    accept=".doc,.docx,.pdf"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />

                  <div className="upload-btn-wrapper">
                    <Button
                      variant="outlined"
                      onClick={() => fileInputRef.current.click()}
                      startIcon={uploading ? <CircularProgress size={20} /> : <CloudUpload />}
                      disabled={uploading}>
                      {uploading ? "Uploading..." : documentUrl ? "Change File" : "Choose File"}
                    </Button>

                    {documentUrl && (
                      <span className="file-success">
                        <CheckCircle fontSize="small" color="success" /> Document Ready
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="action-row">
                <Button variant="outlined" onClick={() => setActiveStep(1)}>
                  Back
                </Button>
                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading || uploading}>
                  {loading ? "Submitting..." : "Submit Abstract"}
                </Button>
              </div>
            </Paper>
          )}
        </div>
      </div>

      <Footer />

      {/* Message Dialog */}
      <Dialog open={dialog.open} onClose={handleCloseDialog}>
        <DialogTitle sx={{ color: dialog.isError ? "red" : "green" }}>{dialog.title}</DialogTitle>
        <DialogContent>
          <Typography>{dialog.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AbstractForm;
